<template>
  <div>
    <div v-if="!isRead" class="navigation-tabs">
      <b-overlay :show="isLoadingCount" class="d-inline-block" rounded opacity="0.6" spinner-small spinner-variant="primary">
        <b-button @click="CountSalary()" class="d-flex" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary">Hitung</b-button>
      </b-overlay>
    </div>

    <div class="tables">
      <b-form-group>
        <b-form-input v-model="filter.employeeName" style="width: 247px;" v-on:keyup.enter="GetSalary()" placeholder="Cari Nama Karyawan..."></b-form-input>
      </b-form-group>
<!--      <BaseTable-->
<!--        :fields="fields"-->
<!--        :items="items"-->
<!--        :loading="loading"-->
<!--        :rows="pagination.total"-->
<!--        :perPage="filter.size"-->
<!--        :currentPage="filter.page"-->
<!--        :handle-page-change="handlePageChange"-->
<!--        :hideView="true"-->
<!--        :hideUpdate="true"-->
<!--        :hideDelete="true"-->
<!--        :HideOptions="true"-->
<!--      />-->
      <b-table :current-page="0" :busy="loading" :per-page="filter.size" :fields="fields" :items="items" :responsive="true">
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
        <template #cell(no)="data">
          {{ data.index + 1 }}
        </template>
        <template #cell()="data">
          <b-form-group style="width: 120px;" v-if="IsNumberic(data)">
            <b-form-input :disabled="isRead" :value="Currency(data.value)" @keypress="IsNumber($event)" @input="SelectedItems(data,$event)" v-on:keyup.enter="QuestionUpdate(data,$event)"></b-form-input>
          </b-form-group>
          <div v-if="!IsNumberic(data)">
            <p>{{ data.value }}</p>
          </div>
        </template>
      </b-table>
      <div class="mt-2">
        <b-pagination v-model="filter.page" :total-rows="pagination.total" :per-page="filter.size">

        </b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import BaseTable from "@/components/BaseTable.vue";
import { BCard, BRow, BCol, BButton, BFormInput,BFormGroup,BTable,BPagination,BOverlay,BSpinner } from "bootstrap-vue";
import utility from '../../libs/utility';
import { successNotification, errorNotification } from "@/auth/utils";
import { CalculateSalaryServices } from '../../services/calculate-salary.service'
export default {
  name: "SalaryTab",
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BaseTable,
    BFormGroup,
    BFormInput,
    BTable,
    BPagination,
    BOverlay,
    BSpinner
  },
  directives: {
    Ripple,
  },
  props: {
    isRead: {
      type: Boolean
    }
  },
  data() {
    return {
      fields: [],
      items: [],
      dataOriginal: [],
      loading: false,
      isLoadingCount: false,
      pagination: {
        total: 0
      },
      filter: {
        employeeName: "",
        page: 1,
        size: 10
      },
    }
  },
  watch: {
    'filter.page': function () {
      this.GetSalary();
    }
  },
  methods: {
    handlePageChange(value) {
      this.loading = true;
      this.filter.page = value;
    },
    IsNumberic(data) {
      // window.console.log(data);
      return utility.isNumeric(data.value);
    },
    SelectedItems(items,e) {
      if (Number.isNaN(utility.RemovePointToInt(e))) {
        items.item[items.field.key] = 0;
      }
      if (!Number.isNaN(utility.RemovePointToInt(e))) {
        items.item[items.field.key] = utility.RemovePointToInt(e);
      }
      // items.item[items.field.key] = utility.RemovePointToInt(e);
      // items.item[items.field.key] = items
    },
    QuestionUpdate(data,event) {
      this.$swal({
        title: "Anda yakin?",
        text: "Anda yakin ingin mengubah data ini?",
        icon: "info",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.onSaveEnter(data,event);
        }
      })
    },
    IsNumber(event) {
      return utility.isNumber(event);
    },
    onSaveEnter(data,event) {
      window.console.log(data);
      // window.console.log(this.dataOriginal[data.index]);
      let findData = {};
      this.dataOriginal[data.index].listData.forEach((item) => {
        if (item[data.field.key] !== undefined) {
          return findData = item;
        }
      });
      // window.console.log(findData);
      let req = {
        id: findData.id,
        amount: data.value
      };
      window.console.log(req);
      this.loading  =  true;
      this.$http.put(`/payslip/employee-payslip/${findData.id}`, req)
        .then((result) => {
          window.console.log(result);
          if (result.data.code === "00") {
            successNotification(this,result.data.message);
            this.GetSalary();
          }
          this.loading = false;
        })
        .catch((e) => {
          errorNotification(this, "Oops!", e.message);
          this.loading = false;
        });
    },
    Currency(value) {
      return utility.FormatCurrency(value);
    },
    async GetSalary() {
      this.loading = true;
      let router = this.$route;
      let req = {
        page: this.filter.page,
        size: this.filter.size,
        payslipId: router.params.id,
        employeeName: this.filter.employeeName
      };
      this.items = [];
      await this.$http.get('/payslip/employee-payslip', {params: req})
        .then((result) => {
          window.console.log(result);
          if (result.data.code === "00") {
            this.fields.push({
              key: 'no',
              label: 'No'
            });
            result.data.data.data.header.forEach((items) => {
              this.fields.push({
                key: items.headerName,
                label: items.headerName
              });
            });
            let dataBody =  result.data.data.data.body;
            this.dataOriginal = dataBody;
            for (let i = 0; i < dataBody.length; i++) {
              let obj = {};
              for (let j = 0; j < dataBody[i].listData.length; j++) {
                const entries = Object.entries(dataBody[i].listData[j]);
                if (entries[0][0] !== 'id') {
                  Object.assign(obj,{[entries[0][0]]: entries[0][1]})
                }
                if (entries[1][0] !== 'id') {
                  Object.assign(obj,{[entries[1][0]]: entries[1][1]})
                }
              }
              this.items.push(obj);
            }
            this.pagination.total = result.data.data.totalElements;
          }
          this.loading = false;
        })
        .catch((e) => {
          errorNotification(this, "Oops!", e.message);
          this.loading  = false;
        });
    },
    async CountSalary() {
      this.isLoadingCount = true;
      let router = this.$route;
      let req = {
        payslipId: router.params.id
      };
      await CalculateSalaryServices.create(req)
        .then((result) => {
          window.console.log(result);
          if (result.code === "00") {
            successNotification(this,result.message);
            this.GetSalary();
          } else {
            errorNotification(this,"Oops!",result.message);
          }
          this.isLoadingCount = false;
        })
        .catch((e) => {
          this.isLoadingCount = false;
          errorNotification(this, "Oops!", e.message);
        });
    }
  },
  mounted() {
    this.GetSalary();
  }
}
</script>
